import styled, { css } from 'styled-components';
import { TabPanelProps } from './TabPanel';

export const Element = styled.div<TabPanelProps>`
  ${({ theme, ...props }) => {
    return css`
      //
    `;
  }};
`;
